<section class="treatment-summary-wrapper">
  <section class="treatment-summary-information"
           [ngSwitch]="summarySectionConfiguration?.type">
    <gen-treatment-selection
      *ngSwitchCase="'priority'"
      [isEditable]="editStatuses.edit"
      [signOffAvailable]="editStatuses.signoff"
      (updateInprogress)="inprogress = $event"
      [sectionConfiguration]="summarySectionConfiguration"
      [workflowId]="workflowId$ | async"
      [revisionId]="revisionId$ | async"
    ></gen-treatment-selection>
    <gen-manual-curation-confirmation
      *ngSwitchCase="'reflex'"
      [isPerformer]="isPerformer"
      [changeOpinionOfMIIn]="changeOpinionOfMIIn"
    ></gen-manual-curation-confirmation>
    <ng-container *ngSwitchCase="'form'">
      <gen-dynamic-form
        *ngFor=" let config of formConfigs;  trackBy: trackByFn"
        class="override-item-as-column treatment-form"
        [formName]="config?.formId"
        [diffFields]="(activeTreatment$ | async)?.updatedFields"
        [formData]="activeTreatment$ | async"
        [stayInFormMode]="true"
        [title]="config?.title"
        [formConfig]="config?.formConfig"
        [listenToDataChange]="true"
        [formVertical]="true"
        [editMode]="true"
        [disabled]="!(editStatuses.edit && isPerformer)"
        (formChange)="updateActiveTreatment($event.form)"
      ></gen-dynamic-form>
    </ng-container>
  </section>
  <div class="action-buttons" *ngIf="editStatuses.edit && isPerformer">
    <gen-button class="Auto_Secondary_Button"
                *ngIf="secondaryButtonActions && secondaryButtonActions.length > 0"
                [text]="secondaryButtonActions[0].label"
                [type]="'secondary'"
                (click)="secondaryButtonActions[0].command()"></gen-button>
    <ng-container
      *ngIf="primaryButtonActions && primaryButtonActions.length > 0"
    >
      <gen-button
        class="Auto_Main_Button"
        [type]="primaryButtonActions.length === 1 ? 'primary' : 'split'"
        (click)="primaryButtonActions[0].command()"
        [text]="primaryButtonActions[0].label"
        [dataPanelPosition]="'TOP'"
        [dropDownIconClass]="'icon__expand'"
        [disabled]="inprogress">
        <section class="split-button-actions">
          <gen-button
            *ngFor="let action of primaryButtonActions"
            [disabled]="inprogress"
            [fullSize]="true"
            [type]="'quite'"
            [text]="action.label"
            buttonClickPermission
            [requiredPermission]="action.requiredPermission"
            (click)="action.command()"
          >
          </gen-button>
        </section>
      </gen-button>

    </ng-container>
  </div>

</section>
